import React from 'react';
import "./Footer.scss"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faMapMarkerAlt, faEnvelope, faPhone, faCopyright} from '@fortawesome/free-solid-svg-icons'
import {useTranslation} from 'react-i18next';


const Footer = ({goToAbout, goToGallery, goToContacts, goToHead}) => {
    const {t, i18n} = useTranslation();

    const changeLanguage = () => {
        i18n.changeLanguage(i18n.language === 'it' ? 'en' : 'it');
        goToHead();
    };

    return (
        <footer>
            <div className="footer__item uno">
                <img className="footer__logo" src={require('./../assets/images/logo.png')} alt={"logo"}/>
            </div>
            <div className="footer__item tre">
                <h2 style={{color: '#b7ac7f', marginTop: 0}}>{t('contacts')}</h2>
            </div>
            <div className="footer__item cinque">
                <h2 style={{color: '#b7ac7f', marginTop: 0}}>{t('links')}</h2>
            </div>

            <div className="footer__item due">
                <div>
                    <p>P.IVA 00000000000</p>
                    <p>C.F. ABCDEF55M04H57HI</p>
                </div>
                <div>
                    <p><FontAwesomeIcon icon={faCopyright} className="footer__icon"
                                        style={{display: 'inline', paddingRight: 10}}/>2020 Studio Signorello - All
                        rights reserved.</p>
                </div>
            </div>
            <div className="footer__item quattro">
                <div style={{display: 'flex', flexFlow: 'row nowrap'}}>
                    <div>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="footer__icon" style={{paddingRight: 10}}/>
                    </div>
                    <div>
                        <p>Piazza Municipio, 62</p>
                        <p>95032 Belpasso (CT)</p>
                        <p>{t('italy')}</p><br/>
                    </div>
                </div>
                <div>
                    <p style={{cursor: 'pointer', margin: 0}}>
                        <FontAwesomeIcon icon={faEnvelope} className="footer__icon"
                                         style={{display: 'inline', paddingRight: 10}}/>studiosignorello@gmail.com
                    </p>
                </div>
                <br/>
                <div>
                    <p style={{cursor: 'pointer', margin: 0}}><FontAwesomeIcon icon={faPhone} className="footer__icon"
                                                                               style={{
                                                                                   display: 'inline',
                                                                                   paddingRight: 10
                                                                               }}/>+39 095 7981872</p>
                </div>
            </div>
            <div className="footer__item sei">
                <a onClick={() => {
                    goToAbout()
                }}>Chi siamo</a><br/>
                <a onClick={() => {
                    goToGallery()
                }}>Progetti</a><br/>
                <a onClick={() => {
                    goToContacts()
                }}>Contatti</a><br/>

                <img className="icon__language" src={require(`./../assets/images/${i18n.language === 'it' ? 'italy' : 'usa'}.png`)} onClick={() => changeLanguage()}/>
            </div>
        </footer>
    );
};

export default Footer;
